import { PROXY_EXTERNAL_MESSAGE_TYPE as d, ProxyBackgroundMessageSchema as u } from "./transport.js";
async function w(e, ...r) {
  const { promise: n, resolve: a, reject: s } = Promise.withResolvers(), t = crypto.randomUUID(), m = (o) => {
    o.source === window && u.refine((i) => i.id === t).safeParseAsync(o.data).then(({ success: i, data: c }) => {
      i && (window.removeEventListener("message", m), c.success ? a(c.result) : s(
        new Error(
          JSON.stringify(`[ProxyMessage] got an error response for request ${t} ${JSON.stringify(c.error)}`)
        )
      ));
    });
  };
  if (window.addEventListener("message", m), typeof e == "string") {
    const [o, i] = r;
    window.postMessage(
      {
        id: t,
        handler: e,
        params: o,
        type: d
      },
      window.origin
    ), i !== void 0 && setTimeout(() => {
      s(`Message ${t} to ${e} timed out`);
    }, i);
  } else {
    const [o] = r;
    window.postMessage(
      {
        id: t,
        message: e,
        type: d
      },
      window.origin
    ), o !== void 0 && setTimeout(() => {
      s(`Message ${t} timed out`);
    }, o);
  }
  return n;
}
const f = (e = 6e4) => new Promise((r, n) => {
  const a = setTimeout(() => {
    n(`Proxy message channel not ready after ${e}ms`);
  }, e), s = () => {
    w("ping", void 0, 100).then(() => {
      clearTimeout(a), r();
    }).catch(() => {
      setTimeout(s, 100);
    });
  };
  s();
});
export {
  w as dispatchProxyMessage,
  f as waitForProxyMessageChannelReady
};
